import i18next, { t } from "i18next";
import { DELETE_DOMAIN_LOADING, LOADING, SET_CURRENT_WEBSITE, SET_CURRENT_WEBSITE_DATA, SET_CURRENT_WEBSITE_PLAN_DATA, SET_MESSAGE } from "../../Actions/Types";
import { DomainDetailsApi } from "../../Api/DomainApi/DomainDetailsApi"
import { getViolationsCountApi, getViolationsListApi } from "../../Api/ViolationsApi";
import parseISODate from "../../Helpers/parseISODate";
import { DomainDeleteApi } from "../../Api/DomainApi/DomainDeleteApi";
import { getUserDetailsService } from "../UserAction/LoginActionService";
import { DomainDetailsService } from "./DomainDetails";
import { postUserActivityListService } from "../UserActivityService";

// service to delete domain details and store
const DomainDeleteService = async (
    token: string, //access token
    websiteID: number, // website Id
    dispatch: Function, // function to store redux data
    latestID: number,
    unchangedDomainName:string
): Promise<any> => {

    // Set Loading
    dispatch({
        type: DELETE_DOMAIN_LOADING,
        payload: true,
    });

    // API to delete domain to pre-purchased plan
    const deleteDomainApiRes = DomainDeleteApi(token, websiteID).then((res) => {

        // check if response status is okay and response data exists
        if (res.status === 200 && res.Data) {

            postUserActivityListService(token, 'Domain Deleted', `${unchangedDomainName}: Deleted successfully`)

            // service to get user details
            const getUserDetailsServiceRes = getUserDetailsService(token, dispatch).then((userRes) => {

                // check if response status is okay
                if (userRes.status === 200) {


                    // service to get domain details
                    const DomainDetailsServiceRes = DomainDetailsService(token, latestID, dispatch).then((websiteDetailsRes) => {


                        // check if response status is okay
                        if (websiteDetailsRes.status === 200) {

                            dispatch({
                                type: DELETE_DOMAIN_LOADING,
                                payload: false,
                            });

                            // dispatch success message
                            dispatch({
                                type: SET_MESSAGE,
                                payload: {
                                    "toast_message": t('Website Deleted successfully.'),
                                    "toast_type": "success"
                                }
                            });

                            return websiteDetailsRes;

                        }
                    });

                    // return Statement
                    return DomainDetailsServiceRes;

                }
                else {

                    // dispatch error message
                    dispatch({
                        type: SET_MESSAGE,
                        payload: {
                            "toast_message": t('Error'),
                            "toast_type": "danger"
                        }
                    });

                    return userRes;
                }

            });

            return getUserDetailsServiceRes;

        }
        else {

            // error message when unable to add a new website
            dispatch({
                type: SET_MESSAGE,
                payload: {
                    "toast_message": t('Website Not Exist Msg'),
                    "toast_type": "danger"
                }
            });

            // remove Loading
            dispatch({
                type: DELETE_DOMAIN_LOADING,
                payload: false,
            });



            return { status: 400 };
        }
    });

    return deleteDomainApiRes

}

export { DomainDeleteService }
